import script from "./QuizzButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzButton.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzButton.vue?vue&type=style&index=0&id=c83d0c1c&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c83d0c1c"]])

export default __exports__